// @flow

import React from 'react';
import { observer } from 'mobx-react';
import { observable, action, computed, runInAction } from 'mobx';
import Lightbox from 'react-images';

type Props = {
    currentImage: number,
    images: Array<any>,
    isOpen: boolean,
    onClose: () => void,
};

@observer
export default class Gallery extends React.Component {
    props: Props;

    @observable images = this.props.images || [];
    @computed get imageCount(): number {
        return this.images.length;
    }
    @observable currentImage = 0;

    @action gotoNextLightboxImage() {
        if (this.currentImage < this.imageCount - 1) {
            this.currentImage++;
        }
        else {
            this.currentImage = 0;
        }
    }

    @action gotoPrevLightboxImage() {
        if (this.currentImage > 0) {
            this.currentImage--;
        }
        else {
            this.currentImage = this.imageCount - 1;
        }
    }

    componentWillReceiveProps(nextProps: Props) {
        runInAction(() => (this.currentImage = nextProps.currentImage));
    }

    render() {
        const { images, isOpen, onClose } = this.props;

        return (
            <Lightbox
                images={ images }
                isOpen={ isOpen }
                currentImage={ this.currentImage }
                onClickPrev={ this.gotoPrevLightboxImage.bind(this) }
                onClickNext={ this.gotoNextLightboxImage.bind(this) }
                onClose={ onClose }
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/global/Gallery/index.js